import { createGlobalStyle } from 'styled-components';

const MobileGlobalStyles = createGlobalStyle`
  /* Prevent iOS bounce effect */
  html {
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  
  body {
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: none;
  }
  
  /* Fix for mobile viewport height */
  #root {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }
  
  /* Prevent zoom on input focus in iOS */
  input, textarea, select {
    font-size: 16px !important;
  }
  
  /* Safe area for notch devices */
  @supports (padding-top: env(safe-area-inset-top)) {
    body {
      padding-top: env(safe-area-inset-top);
      padding-bottom: env(safe-area-inset-bottom);
      padding-left: env(safe-area-inset-left);
      padding-right: env(safe-area-inset-right);
    }
  }
`;

export default MobileGlobalStyles;